// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__qCjaj","content":"styles_content__19EfF","selectAll":"styles_selectAll__2JAzt"};